import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";
import { GlassButton } from "../components/PrimaryButton";
import { useAuth } from "../lib/auth";
import api from "../lib/api";

const Welcome = () => {
  const nav = useNavigate();
  const { user } = useAuth();

  // Already signed in? send them straight to the right next screen.
  useEffect(() => {
    if (user && user.role) {
      if (user.subscription_status !== "active") nav("/subscribe", { replace: true });
      else if (!user.onboarding_completed) nav("/onboarding", { replace: true });
      else if (user.role === "client" && !user.linked_practitioner_id) nav("/link-practitioner", { replace: true });
      else nav("/dashboard", { replace: true });
    }
  }, [user, nav]);

  const choose = async (role) => {
    localStorage.setItem("well_pending_role", role);
    if (user) {
      try {
        await api.post("/auth/set-role", { role });
        if (user.subscription_status === "active") {
          if (!user.onboarding_completed) {
            window.location.replace("/onboarding");
          } else if (role === "client" && !user.linked_practitioner_id) {
            window.location.replace("/link-practitioner");
          } else {
            window.location.replace("/dashboard");
          }
          return;
        }
      } catch (e) { /* fall through */ }
    }
    nav("/pricing");
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const signIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16 gap-12 well-page-enter">
      <Logo size="text-7xl" showTagline />
      <div className="w-full max-w-sm flex flex-col gap-4 mt-4">
        <GlassButton onClick={() => choose("therapist")} data-testid="welcome-therapist-btn">
          I&apos;m a Therapist
        </GlassButton>
        <GlassButton onClick={() => choose("coach")} data-testid="welcome-coach-btn">
          I&apos;m a Coach
        </GlassButton>
        <GlassButton onClick={() => choose("client")} data-testid="welcome-client-btn">
          I&apos;m a Client
        </GlassButton>
      </div>
      <button
        onClick={signIn}
        data-testid="welcome-signin-link"
        className="text-sm font-medium text-[#4A5D52] underline underline-offset-4 hover:text-[#2A3B32] transition-colors"
      >
        Already have an account? Sign in
      </button>
    </div>
  );
};

export default Welcome;
